import React, { useState } from 'react';
import { Reveal } from './ui/Reveal';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
export function GallerySection() {
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);
  const images = [{
    id: 1,
    url: 'https://cdn.magicpatterns.com/uploads/qidxRpRJDtuiRTEgT9Ri8v/4acc3995-2907-43b4-81ea-c89ce73abe8f.jpg',
    title: 'Comunidad Vimutti',
    category: 'Presencial'
  }, {
    id: 2,
    url: 'https://cdn.magicpatterns.com/uploads/hXjKLk1SmGDip31wTotPCN/08b61835-8ab2-463e-b65b-38459f762e6c.jpg',
    title: 'Meditación Guiada',
    category: 'Presencial'
  }, {
    id: 3,
    url: 'https://cdn.magicpatterns.com/uploads/ina4wPiiq9Xy4dmoMFZWZr/82e937cb-d255-4949-b7ab-1dac09cbe490.jpg',
    title: 'Clase Grupal al Aire Libre',
    category: 'Presencial'
  }, {
    id: 4,
    url: 'https://cdn.magicpatterns.com/uploads/eLCi8Mc8maDEGDTYiFUtoc/8a001901-b753-4cb9-9567-6df83ff681e6.jpg',
    title: 'Grupo Vimutti',
    category: 'Presencial'
  }, {
    id: 5,
    url: 'https://cdn.magicpatterns.com/uploads/foNbicYHCajTkAzQWE6h5n/b91c9542-0405-460e-b8fd-a56bb69d0dd9.jpg',
    title: 'Práctica con Props',
    category: 'Presencial'
  }, {
    id: 6,
    url: 'https://cdn.magicpatterns.com/uploads/paVn64dUMdYNFVFKNizuJE/52f2ef4c-ed60-423d-8f49-d280de1d279b.jpg',
    title: 'Comunidad en Armonía',
    category: 'Presencial'
  }, {
    id: 7,
    url: 'https://cdn.magicpatterns.com/uploads/1B7uHco6zco23WUd6j9zeF/fe0f6d13-0b00-4d3a-83d5-636fccca7484.jpg',
    title: 'Selfie Grupal',
    category: 'Presencial'
  }, {
    id: 8,
    url: 'https://cdn.magicpatterns.com/uploads/rZCfvAJeqMkNnEipwo1Cbe/7752c8a7-9db8-48bc-9b10-fb85c8be6b84.jpg',
    title: 'Sesión de Meditación',
    category: 'Presencial'
  }, {
    id: 9,
    url: 'https://cdn.magicpatterns.com/uploads/c1ZHEHxGXHFAVvU2z3ymhE/dcc1f3f3-d7dd-43a9-9c5c-d5bda931f3df.jpg',
    title: 'Grupo al Aire Libre',
    category: 'Presencial'
  }, {
    id: 10,
    url: 'https://cdn.magicpatterns.com/uploads/qearTC5wExt7FpEkJKJGuj/bb75b3e1-5830-4365-8f12-0e3658c128b7.jpg',
    title: 'Práctica Guiada',
    category: 'Presencial'
  }];
  const openLightbox = (index: number) => {
    setSelectedImageIndex(index);
    document.body.style.overflow = 'hidden';
  };
  const closeLightbox = () => {
    setSelectedImageIndex(null);
    document.body.style.overflow = 'auto';
  };
  const goToPrevious = () => {
    if (selectedImageIndex !== null) {
      setSelectedImageIndex(selectedImageIndex === 0 ? images.length - 1 : selectedImageIndex - 1);
    }
  };
  const goToNext = () => {
    if (selectedImageIndex !== null) {
      setSelectedImageIndex(selectedImageIndex === images.length - 1 ? 0 : selectedImageIndex + 1);
    }
  };
  return <section className="py-24 px-6 md:px-16 bg-sand" data-id="element-1040">
      <div className="max-w-7xl mx-auto" data-id="element-1041">
        <Reveal className="text-center mb-16" data-id="element-1042">
          <span className="inline-block bg-sage-light/30 text-earth text-xs font-semibold uppercase tracking-widest px-3.5 py-1.5 rounded-full mb-4" data-id="element-1043">
            Galería
          </span>
          <h2 className="font-display text-4xl md:text-5xl text-earth mb-4" data-id="element-1044">
            Nuestros Espacios
          </h2>
          <p className="text-stone text-lg max-w-2xl mx-auto" data-id="element-1045">
            Conoce los lugares donde practicamos y la comunidad que formamos
          </p>
        </Reveal>

        {/* Masonry Grid Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1046">
          {images.map((image, index) => <Reveal key={image.id} delay={index * 50} data-id="element-1047">
              <div className="group relative bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer" onClick={() => openLightbox(index)} data-id="element-1048">
                <div className="relative overflow-hidden" data-id="element-1049">
                  <img src={image.url} alt={image.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-1050" />
                  <div className="absolute inset-0 bg-gradient-to-t from-earth/60 via-earth/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-1051" />

                  {/* Overlay Info */}
                  <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-1052">
                    <span className="inline-block px-3 py-1 bg-sage-light/90 text-sage text-xs font-semibold rounded-full mb-2" data-id="element-1053">
                      {image.category}
                    </span>
                    <h3 className="font-display text-xl text-white" data-id="element-1054">
                      {image.title}
                    </h3>
                  </div>
                </div>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={400} className="mt-16 text-center" data-id="element-1055">
          <div className="bg-white rounded-3xl p-8 max-w-2xl mx-auto" data-id="element-1056">
            <p className="text-stone leading-relaxed mb-6" data-id="element-1057">
              ¿Quieres compartir tu experiencia en Vimutti Yoga? Etiquétanos en
              tus fotos de práctica y podrías aparecer en nuestra galería.
            </p>
            <div className="flex items-center justify-center gap-4 text-sm text-stone" data-id="element-1058">
              <span className="flex items-center gap-2" data-id="element-1059">
                📸 Instagram:{' '}
                <span className="text-sage font-semibold" data-id="element-1060">@vimuttiyoga</span>
              </span>
            </div>
          </div>
        </Reveal>
      </div>

      {/* Lightbox Modal */}
      {selectedImageIndex !== null && <div className="fixed inset-0 z-50 bg-earth/95 backdrop-blur-sm flex items-center justify-center p-4" onClick={closeLightbox} data-id="element-1061">
          {/* Close Button */}
          <button onClick={closeLightbox} className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors z-10" aria-label="Cerrar" data-id="element-1062">
            <X className="w-6 h-6" data-id="element-1063" />
          </button>

          {/* Previous Button */}
          <button onClick={e => {
        e.stopPropagation();
        goToPrevious();
      }} className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors z-10" aria-label="Anterior" data-id="element-1064">
            <ChevronLeft className="w-6 h-6" data-id="element-1065" />
          </button>

          {/* Next Button */}
          <button onClick={e => {
        e.stopPropagation();
        goToNext();
      }} className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors z-10" aria-label="Siguiente" data-id="element-1066">
            <ChevronRight className="w-6 h-6" data-id="element-1067" />
          </button>

          {/* Image Container */}
          <div className="relative max-w-6xl max-h-[90vh] w-full" onClick={e => e.stopPropagation()} data-id="element-1068">
            <img src={images[selectedImageIndex].url} alt={images[selectedImageIndex].title} className="w-full h-full object-contain rounded-2xl" data-id="element-1069" />

            {/* Image Info */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-earth/90 to-transparent p-6 rounded-b-2xl" data-id="element-1070">
              <span className="inline-block px-3 py-1 bg-sage-light/90 text-sage text-xs font-semibold rounded-full mb-2" data-id="element-1071">
                {images[selectedImageIndex].category}
              </span>
              <h3 className="font-display text-2xl text-white" data-id="element-1072">
                {images[selectedImageIndex].title}
              </h3>
              <p className="text-cream/80 text-sm mt-1" data-id="element-1073">
                {selectedImageIndex + 1} / {images.length}
              </p>
            </div>
          </div>
        </div>}
    </section>;
}